import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';



export function getResultadoExamenListSuccess(resultadoexamen) {
  return {type: types.LOAD_RESULTADOEXAMEN_LIST_SUCCESS, resultadoexamen};
}



export function getResultadoExamenList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ResultadoExamenApi.getResultadoExamenList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(resultadoexamen => {                  
                  dispatch(getResultadoExamenListSuccess(resultadoexamen));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getResultadoExamenSuccess(catalogo) {
  return {type: types.LOAD_RESULTADOEXAMEN_SUCCESS, catalogo};
}

export function getResultadoExamen(id, filtro, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ResultadoExamenApi.getResultadoExamen(id, filtro, token).then(resultadoexamen => {   
        dispatch(getResultadoExamenSuccess(resultadoexamen));
        return resultadoexamen;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function getResultadoExamenUsuario(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ResultadoExamenApi.getResultadoExamenUsuario(id, token).then(resultadoexamen => {   
        dispatch(getResultadoExamenSuccess(resultadoexamen));
        return resultadoexamen;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function getResultadoExamenCruso(cursoId, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ResultadoExamenApi.getResultadoExamenCruso(cursoId, token).then(resultadoexamen => {   
        dispatch(getResultadoExamenSuccess(resultadoexamen));
        return resultadoexamen;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(resultadoexamen) {
  return {type: types.SAVE_RESULTADOEXAMEN_SUCCESS, resultadoexamen};
}


export function save(resultadoexamen, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ResultadoExamenApi.save(resultadoexamen, token).then(resultadoexamenGuardado => {   
    //dispatch(saveSuccess(resultadoexamenGuardado));
        dispatch(saveSuccess(resultadoexamenGuardado));    
    }).catch(error => {
		dispatch(ajaxCallError()); 
        throw(error);
    });
  };
}

export function saveSinCadena(resultadoexamen, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ResultadoExamenApi.saveSinCadena(resultadoexamen, token).then(resultadoexamenGuardado => {   
    //dispatch(saveSuccess(resultadoexamenGuardado));
        dispatch(saveSuccess(resultadoexamenGuardado));    
    }).catch(error => {
		dispatch(ajaxCallError()); 
        throw(error);
    });
  };
}




export function getResultadoExamenComboSuccess(datos) {
  return {type: types.GET_RESULTADOEXAMENS_COMBO_SUCCESS, datos};
}

export function getResultadoExamenCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().ResultadoExamenApi.getResultadoExamenCombo(token).then(datos => {   
        
      dispatch(getResultadoExamenComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(resultadoexamen) {
  return {type: types.BORRAR_RESULTADOEXAMEN_SUCCESS, resultadoexamen};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ResultadoExamenApi.borrar(id, token ).then(resultadoexamen => {
               
                  dispatch(borrarSuccess(resultadoexamen));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(resultadoexamen) {
  return {type: types.ACTIVAR_RESULTADOEXAMEN_SUCCESS, resultadoexamen};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ResultadoExamenApi.activar(id, token).then(resultadoexamen => {
               
                  dispatch(activarSuccess(resultadoexamen));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos
	}
  return {type: types.SET_FILTRO_RESULTADOEXAMEN, filtro};
}



